import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import OGeetHomePage from './pages/OGeetHomePage';
import OGeetMomentsPage from './pages/OGeetMomentsPage';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import MenuPage from './pages/MenuPage';
import GeetSetMenuPage from './pages/GeetSetMenuPage';
import OGeetSetMenuPage from './pages/OGeetSetMenuPage';
import ContactPage from './pages/ContactPage';
import GalleryPage from './pages/GalleryPage';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import { trackPageView } from './lib/analytics';
import './App.css';

const Chrome = ({ children }) => {
  const location = useLocation();
  const isGeet = location.pathname.startsWith('/geet');
  const isAdmin = location.pathname.startsWith('/admin');

  useEffect(() => {
    if (!isAdmin) trackPageView(location.pathname);
  }, [location.pathname, isAdmin]);

  return (
    <>
      {isGeet && <Navbar />}
      {children}
      {isGeet && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App bg-[#FDFBF7] min-h-screen">
      <BrowserRouter>
        <Chrome>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/ogeet" element={<OGeetHomePage />} />
            <Route path="/ogeet/set-menu" element={<OGeetSetMenuPage />} />
            <Route path="/ogeet/moments" element={<OGeetMomentsPage />} />
            <Route path="/geet" element={<HomePage />} />
            <Route path="/geet/about" element={<AboutPage />} />
            <Route path="/geet/menu" element={<MenuPage />} />
            <Route path="/geet/set-menu" element={<GeetSetMenuPage />} />
            <Route path="/geet/contact" element={<ContactPage />} />
            <Route path="/geet/gallery" element={<GalleryPage />} />
            <Route path="/admin/analytics" element={<AnalyticsDashboard />} />
          </Routes>
        </Chrome>
      </BrowserRouter>
    </div>
  );
}

export default App;
